import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <div className="font-mono text-[var(--cyan)] blink">// AUTHENTICATING…</div>
      </div>
    );
  }
  if (!user || !user.id) return <Navigate to="/login" replace />;
  return children;
}
